import { useEffect, useState } from "react";

// Gates chart entrance animation (isAnimationActive) on the OS-level
// prefers-reduced-motion setting. This is separate from — and in addition
// to — the global prefers-reduced-motion CSS block in index.css, which
// neutralizes the pre-existing pulse-glow keyframe and hover transforms;
// Recharts' animations are driven by props, not CSS, so they need their own
// gate.
export default function useReducedMotion() {
  const [reduced, setReduced] = useState(
    () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches,
  );

  useEffect(() => {
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handler = (e) => setReduced(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return reduced;
}
